module.exports = __webpack_public_path__ + "static/media/eye-view.b26e8663.svg";